/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentNotificationSetting } from './CommentNotificationSetting';
import {
    CommentNotificationSettingFromJSON,
    CommentNotificationSettingFromJSONTyped,
    CommentNotificationSettingToJSON,
} from './CommentNotificationSetting';

/**
 * 
 * @export
 * @interface TrackCommentNotificationResponse
 */
export interface TrackCommentNotificationResponse {
    /**
     * 
     * @type {CommentNotificationSetting}
     * @memberof TrackCommentNotificationResponse
     */
    data?: CommentNotificationSetting;
}

/**
 * Check if a given object implements the TrackCommentNotificationResponse interface.
 */
export function instanceOfTrackCommentNotificationResponse(value: object): value is TrackCommentNotificationResponse {
    let isInstance = true;

    return isInstance;
}

export function TrackCommentNotificationResponseFromJSON(json: any): TrackCommentNotificationResponse {
    return TrackCommentNotificationResponseFromJSONTyped(json, false);
}

export function TrackCommentNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackCommentNotificationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CommentNotificationSettingFromJSON(json['data']),
    };
}

export function TrackCommentNotificationResponseToJSON(value?: TrackCommentNotificationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CommentNotificationSettingToJSON(value.data),
    };
}

